import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import './index.css';
import { store } from './store';
import { Provider } from 'react-redux';
import { persistStore } from "redux-persist";
import { PersistGate } from "redux-persist/integration/react";

import App from './App';
import AuthProvider from 'hoc/AuthProvider';

let persistor = persistStore(store);

ReactDOM.render(
  <AuthProvider>
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <App />
      </PersistGate>
    </Provider>
  </AuthProvider>
  , document.getElementById('root')
);